import LogoNoMuscleSvg from 'util/svg/LogoNoMuscleSvg';
import React from 'react';

const AddMoneyHeader = () => (
    <div style={{
        width: 'auto',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '43px',
        backgroundColor: '#80af76',
        color: '#447337',
        fontSize: '20px',
        fontWeight: 'bold',
        padding: '0 4px'
    }}>
        <div className="position-relative" style={{display: 'flex', alignItems: 'center'}}>
            <LogoNoMuscleSvg size={50} color={'#447337'}/>
            <div style={{position: 'absolute', left: '54%', top: '41%', transform: 'translate(-50%, -50%)'}}>
                +
            </div>
        </div>
        <div>Add Money</div>
        <div style={{width: '50px'}}/>
    </div>
);

export default AddMoneyHeader;